/* eslint-disable max-len */
import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ClientsAction from '../app/store/actions/clients';

import NumbersHelper from '../helpers/numbers';
import ModalComponent from '../components/modal';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class ClientsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'ASC',
      field: 'clientId',
      showModal: false,
      clientId: '',
      contractCheck: false,
      spotCheck: false,
      message: '',
      showCannotActivate: false
    };
  }

  componentDidMount() {
    this.searchClients();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchClients();
  }

  searchClients = async () => {
    const {
      search, page, limit, orderBy, field = '',
    } = this.state;
    const skip = (page - 1) * limit;
    await this.props.searchItems(limit, skip, search, false, orderBy, field);
  }

  activeClient = async (clientId, status, row) => {
    const { companyTag } = this.props.settings;

    if (companyTag == 'chile' && status === 'active' && (row.sphereClient.activity==0 || !row.sphereClient.activity)) {
      this.setState({ showCannotActivate: true });
      return;
    }

    await this.props.activeClient(clientId, status);
    await this.searchClients();
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchClients();
  }

  changeModal = () => {
    this.setState({
      showModal: true,
    });
  };

  disableModal = () => {
    this.setState({
      showModal: false,
      clientId: '',
      contractCheck: false,
      spotCheck: false,
      message: '',
    });
  };

  setValue = (attr, value) => {
    if (attr === 'contractCheck' || attr === 'spotCheck') {
      this.setState({
        [attr]: !value,
      });
    } else if (attr === 'clientId') {
      if (!parseInt(value) || parseInt(value) >= 0 || value === '') {
        this.setState({
          [attr]: value,
        });
      }
    }
  };

  renderOrdersCategory = categories => (
    <div className="form-main">
      <div className="text-align-modal">
        <h4><Translate value="exportProducts" /></h4>
        <div className="row mt-5">
          <div className="col-4 d-flex align-items-end justify-content-center">
            <h5>
              <Translate value="clientId" />
              {': '}
            </h5>
          </div>
          <div className="col-4 d-flex justify-content-start">
            <input
              style={{
                width: '25vw',
              }}
              type="number"
              className="form-control"
              onChange={e => this.setValue('clientId', e.target.value)}
              value={this.state.clientId}
            />
          </div>
        </div>
        {/*  <div className='row mt-3 '>
          <div className='col-4 d-flex align-items-end justify-content-center'>
            <h5> <Translate value="product" /> :</h5>
          </div>
          <div className="form-check col-4 d-flex justify-content-start ml-2">
            <input
              onClick={() => this.setValue('contractCheck', this.state.contractCheck)}
              onChange={() => { }}
              type="checkbox"
              className="form-check-input"
              checked={!!this.state.contractCheck}
              id="contractCheck"
            />
            <span><Translate value="contract" /></span>
          </div>
        </div>
        <div className="row ">
          <div className='col-4' />
          <div className="form-check col-4 d-flex justify-content-start ml-2">
            <input
              onClick={() => this.setValue('spotCheck', this.state.spotCheck)}
              onChange={() => { }}
              type="checkbox"
              className="form-check-input"
              checked={!!this.state.spotCheck}
              id="spotCheck"
            />
            <span><Translate value="spot" /></span>
          </div>
        </div> */}
        <div className=" row d-flex justify-content-center mt-5">
          <div>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => this.disableModal()}
            >
              <Translate value="cancel" />
            </button>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-primary margin-left-btn-modal"
              onClick={() => this.getData()}
            >
              <Translate value="export" />
            </button>
          </div>
        </div>
        <div className="row mt-4 d-flex justify-content-center">
          <p className="color-red ">{this.state.message}</p>
        </div>
      </div>
    </div>
  );

  getData = () => {
    const { clientId } = this.state;
    if (clientId === '') {
      this.setState({ message: I18n.t('EnterCode') });
      this.renderOrdersCategory(this.props.categories);
    } /* else if (!spotCheck && !contractCheck) {
      this.setState({ message: I18n.t('EnterType') })
      this.renderOrdersCategory(this.props.categories)
    } */ else {
      this.props.customerProducts(false, true, clientId);
      this.disableModal();
    }
  };

  render() {
    const { limit, page, showModal, showCannotActivate } = this.state;
    const { clients = {} } = this.props;
    const { companyTag } = this.props.settings;

    const tableHeader = [
      { key: 'clientId', value: I18n.t('clientId') },
      { key: 'client', value: I18n.t('client') },
      { key: 'nickname', value: I18n.t('nickname') },
      { key: 'address', value: I18n.t('address') },
      { key: 'cep', value: I18n.t('cep') },
      { key: 'creditLimit', value: I18n.t('creditLimit') },
      { key: 'city', value: I18n.t('city') },
      { key: 'state', value: I18n.t('state') },
      { key: 'freight', value: I18n.t('freight') },
      { key: 'lastAcess', value: I18n.t('lastAcess') },
      { key: 'email', value: I18n.t('email') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];
    const tableData = (clients.client || []).map(
      (row, index) => ({
        key: index,
        clientId: row.clientId,
        client: row.sphereClient.name,
        nickname: row.nickname,
        address: row.sphereClient.address,
        cep: row.sphereClient.cep,
        creditLimit: NumbersHelper.toCurrency(row.sphereClient.creditLimit),
        city: row.sphereClient.city,
        state: row.sphereClient.state,
        freight: row.freight,
        lastAcess: row.userClients && row.userClients.length > 0 && row.userClients[0].user.lastAccess ? new Date(row.userClients[0].user.lastAccess).toLocaleString() : '',
        email: row.userClients && row.userClients.length > 0 && row.userClients[0].user.lastAccess ? row.userClients[0].user.email : '',
        status: (
          <div className="row margin-left-0">
            <button
              type="button"
              className={`btn btn-${row.status === 'active' ? 'warning' : 'dark'} promotion-btn-${
                row.status === 'active' ? 'warning' : 'active'}`}
              onClick={() => this.activeClient(row.clientId, row.status === 'active' ? 'inactive' : 'active', row)}
            >
              <Translate value={row.status === 'active' ? 'disable' : 'active'} />
            </button>
          </div>
        ),
        action: (
          <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
            <div className="btn-group" role="group">
              <button
                id="btnGroupDrop1"
                type="button"
                className="btn btn-secondary dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <Translate value="action" />
              </button>
              <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <button
                  type="button"
                  onClick={() => history.push({
                    pathname: ROUTES.USERS,
                    screenComming: 'client',
                    item: row,
                  })}
                  className="dropdown-item dropdown-table"
                >
                  <Translate value="users" />
                </button>
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => history.push({
                    pathname: ROUTES.FORM,
                    screenComming: 'clientParameters',
                    item: row,
                  })}
                >
                  <Translate value="edit" />
                </button>
              </div>
            </div>
          </div>
        ),
      }),
    );

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'clientParameters' }} />
        
        {companyTag === 'chile' && (
          <React.Fragment>
            <button
              onClick={() => history.push(ROUTES.UPLOAD_CLIENTS)}
              type="button"
              className="btn btn-secondary margin-left-10"
            >
              <Translate value="importClient" />
            </button>

            <button
              onClick={() => history.push(ROUTES.UPLOAD_CLIENT_USERS)}
              type="button"
              className="btn btn-secondary margin-left-10"
            >
              <Translate value="importClientUser" />
            </button>
          </React.Fragment>
        )}

        <button
          onClick={() => this.props.getCsvClientsReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>

        <button
          onClick={() => this.changeModal()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="exportProducts" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          showButtons
          showOk={false}
          visible={showModal}
          closeModal={() => this.disableModal()}
          type="orderCategory"
          size={{ width: '40%', height: '20%' }}
          id="modalOrderCategory"
          bodyFuncComponent={() => this.renderOrdersCategory(this.props.categories)}
        />
        <ModalComponent
          title={I18n.t('warning')}
          body={I18n.t('clienteWithoutActivity')}
          visible={showCannotActivate}
          closeModal={() => this.setState({ showCannotActivate: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '300px', height: '210px' }}
          showButtons
          confirmModal={() => this.setState({ showCannotActivate: false })}
        />
        <Table
          title={I18n.t('clients')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={clients.count && clients.count.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  activeClient: (clientId, status) => dispatch(ClientsAction.updateClients({ clientId, status })),
  searchItems: (limit, skip, search, force, order, field) => dispatch(
    ClientsAction.getClient(limit, skip, search, force, order, field),
  ),
  getCsvClientsReport: () => dispatch(ClientsAction.getCsvClientsReport()),
  customerProducts: (spotCheck, contractCheck, clientId) => dispatch(ClientsAction.customerProducts(spotCheck, contractCheck, clientId)),
});

const mapStateToProps = state => ({
  clients: state.clients.clients,
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientsPage);
